var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 48 48",
    height: 512,
    viewBox: "0 0 48 48",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#689f38"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 38,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 11.412
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 10,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 36.124,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 11.876,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.124,
    cy: 31,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.876,
    cy: 17,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 24,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 24,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.124,
    cy: 17,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.876,
    cy: 31,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 11.876,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 36.124,
    r: 5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22 31.829-7.414-7.415 2.828-2.828 4.586 4.585 9.586-9.585 2.828 2.828z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.ab6f06f6057418b4d81e10446c81f421.svg";
export { ForwardRef as ReactComponent };